import 'shared/connector'
import { referrerDetector } from 'api/referrerDetector'

import './auth-check'

export function init() {
	referrerDetector.capture(null, null)
}
